export { DebugInfoDialog } from "./debug-info-dialog";
